export default {
    DEV_LOCAL: 'dev-local',
    DEVELOPMENT: 'development',
    DEV: 'dev',
    NON_PROD: 'nonprod',
    UAT: 'uat',
    PROD: 'prod',
    PRODUCTION: 'production',
    nonprod: 'development', // key expected from REACT_APP_ENV env
    uat: 'uat', // key expected from REACT_APP_ENV env
    prod: 'prod', // key expected from REACT_APP_ENV env
};
